










import { Vue, Component, Prop } from 'vue-property-decorator';
import { IField } from '@/fields/types/field';
import FieldContentContainer from '@/fields/components/FieldContentContainer.vue';
import { IMergeFieldMapObject } from '@/fields/merge-field/types/merge-field-map-object';

@Component({
  components: {
    FieldContentContainer,
  },
})
export default class MergeField extends Vue {
  @Prop() field!: IField;
  @Prop({ default: false }) isActive: boolean;
  @Prop() mergeFieldMapObject: IMergeFieldMapObject;
  @Prop() showInitials: boolean;

  get value(): string {
    if (!this.field.value) {
      return this.safeValue;
    }

    if (!this.field.displayProperty) {
      return this.safeValue;
    }

    const propertyList: string[] = this.field.displayProperty.split('.');
    const mapObject = this.mergeFieldMapObject[propertyList[0]];
    if (!mapObject) {
      return this.safeValue;
    }

    if (propertyList.length < 2) {
      return mapObject;
    }

    return this.mergeFieldMapObject[propertyList[0]][propertyList[1]] || this.field.value;
  }

  get safeValue() {
    return this.field.label || this.field.value || '';
  }
}
